import { ExternalLink, Instagram, Linkedin, Twitter } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export type SocialPlatform = "instagram" | "linkedin" | "other" | "twitter";

export function detectSocialPlatform(url: string): SocialPlatform {
  if (!url) {
    return "other";
  }
  try {
    const hostname = new URL(url).hostname.toLowerCase();
    const normalizedHostname = hostname.startsWith("www.")
      ? hostname.slice(4)
      : hostname;
    const parts = normalizedHostname.split(".");
    const rootDomain =
      parts.length >= 2 ? parts.slice(-2).join(".") : normalizedHostname;
    switch (rootDomain) {
      case "linkedin.com":
        return "linkedin";
      case "instagram.com":
        return "instagram";
      case "twitter.com":
      case "x.com":
        return "twitter";
      default:
        return "other";
    }
  } catch {
    return "other";
  }
}

const iconMap: Record<SocialPlatform, LucideIcon> = {
  linkedin: Linkedin,
  instagram: Instagram,
  twitter: Twitter,
  other: ExternalLink,
};

export function getSocialIcon(platform: SocialPlatform): LucideIcon {
  return iconMap[platform];
}
